<template>
  <tfoot>
    <tr>
      <td
        colspan="3"
        class="pl-1"
      >{{ getTranslation('main.status') }}</td>

      <td
        colspan="2"
        v-if="showWinnings"
      >{{ getTranslation(winningsLabel) }}</td>

      <td
        colspan="2"
        v-if="payoutTax"
      >{{ getTranslation('print.payout_tax') }}</td>

      <td
        colspan="2"
        v-if="payoutAmount && payoutTax"
      >{{ getTranslation(payoutLabel) }}</td>
    </tr>
    <tr class="ticket-check__statuses">
      <td
        colspan="3"
        class="pl-1 text-uppercase"
      >{{ getTranslation('ticket.status_' + ticket.status.value.toLowerCase()) }}</td>

      <td
        colspan="2"
        v-if="showWinnings"
      >{{ formatNumber(winningsAmount, 2, 2) }} </td>

      <td
        colspan="2"
        v-if="payoutTax"
      >{{ payoutTax }}</td>

      <td
        colspan="2"
        v-if="payoutAmount && payoutTax"
      >{{ formatNumber(payoutAmount, 2, 2) }}</td>
    </tr>
  </tfoot>
</template>

<script>
import helpers from '../../../services/helpers';

export default {
  props: {
    ticket: {
      type: Object,
      required: true,
    },
  },
  computed: {
    payoutTaxEnabled() {
      const { taxes } = this.$store.getters;
      return taxes.payout.value && !taxes.payout.hideTax;
    },
    showPayoutInfo() {
      const payoutVisibilityTicketStatusList = ['WON', 'PAYEDOUT', 'OPEN'];
      const ticketStatus = (this.ticket.status || {}).value;
      return payoutVisibilityTicketStatusList.indexOf(ticketStatus) > -1;
    },
    payoutTax() {
      const payoutTaxValue = this.ticket.payoutTax || this.ticket.maxPossiblePayoutTax || 0;
      return this.showPayoutInfo && this.payoutTaxEnabled && payoutTaxValue;
    },
    payoutAmount() {
      const {
        maxPossiblePayout,
        status,
        displayPayout,
      } = this.ticket;

      const statusValue = (status || {}).value || '';

      const statusMappedValues = {
        WON: displayPayout,
        PAYEDOUT: displayPayout,
        OPEN: maxPossiblePayout,
      };
      return statusMappedValues[statusValue] || 0;
    },
    winningsAmount() {
      return this.ticket.winnings || this.ticket.maxPossibleWin || 0;
    },
    winningsLabel() {
      const { status = {} } = this.ticket;
      return status.value === 'PAYEDOUT' || status.value === 'WON'
        ? 'main.winnings'
        : 'print.max_winnings';
    },
    payoutLabel() {
      const { status = {} } = this.ticket;
      return status.value === 'PAYEDOUT' || status.value === 'WON'
        ? 'main.payout'
        : 'betslip.possible_payout';
    },
    showWinnings() {
      const isSystem = this.ticket.type === '2';
      const systems = this.ticket.ticketCombinationGroups;
      return !isSystem || (isSystem && systems && systems.length > 1);
    },
  },
  methods: {
    getTranslation(key) {
      return this.$store.getters.getTranslation(key);
    },
    formatNumber: helpers.formatNumber,
  },
};
</script>
